import { render, staticRenderFns } from "./SmartMarkdown.vue?vue&type=template&id=0aba4ccc&"
import script from "./SmartMarkdown.vue?vue&type=script&lang=js&"
export * from "./SmartMarkdown.vue?vue&type=script&lang=js&"
import style0 from "./SmartMarkdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports